/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector,useDispatch } from "react-redux"
import { useEffect,useCallback,useContext ,useState} from "react"
import { useLocation,useSearchParams } from "react-router-dom"
import { useEditObserverMutation, useExportObserversListMutation,useDeleteObserverMutation } from "../../features/observerSlice"
import Debounce from "../../CommonMethods/Debounce"
import { limitReducer, resetArrays } from "../../redux/MultiselectRows"
import Table from "./Components/Table"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import { useGetObserversQuery } from "../../features/observerSlice"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import ConfirmationPrompt from "../../components/ConfirmationPrompt"
import AnimatedModel from "../../components/Animation/AnimatedModel"
import TopBarIndividual from './TopBar/index'
import moment from "moment"
import { handleAddFilterValues } from "../../redux/systemConfigSlice"
import { pushToSubDivArray ,popFromSubDivArray} from "../ManageAdminAndCoporateUser/subdivisionSlice"
import { convertDatesToEpochUTC } from "../../CommonMethods/ConvertFilterDatetoEpochUtcFormat"
import ObserverAdvancedSearch from "./Components/AdvancedSearch/index"
import { resetObserverSearch, setObsSearchApplied } from "../../redux/observerSearchSlice"

export default function ManageObserver(){
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar,isAdvancedSearchOpen} = useContext(GlobalContext);
    const [editObserver]=useEditObserverMutation()
    const [exportObservers]=useExportObserversListMutation()
    const [deleteObserver]=useDeleteObserverMutation()
    const [suggestions,setSuggestions]=useState("")
    const [limit,setLimit]=useState("15")
    const [skip,setSkip]=useState(true)
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const location=useLocation()
    const dispatch=useDispatch()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [loading,setLoading]=useState(false)
    const [isSortselected,setisSortSelected]=useState(false)
    const selectedRows=useSelector(state=>state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const [confirmationState, setConfirmationState] = useState({isOpen:false,rowData:'',multirow:'',user_names:[]});
    const [textAreaMsg,setTextAreaMsg]=useState('')
    const [emptyField,setEmptyField]=useState(false);
    const [isChangeStatusOPen, setIsChangeStatusOpen] = useState(false)
    const [isChangeStatusOPenxl, setIsChangeStatusOpenxl] = useState(false)
    const auth=useSelector(state=>state?.auth)
    const {userType} = auth
    const [multiDelete, setMultiDelete] = useState(false);
    const observerSearch = useSelector(state => state.observerSearchData);
    const searchApplied = useSelector((state) => state.observerSearchData.obssearchApplied);


    const [selectedOrganizationName, setSelectedOrganizationName] = useState([{
        organization_name: '',
        organization_id: '',
    }]);
    const [subDivisionDataLoading,setSubDivisionDataLoading]= useState(false)
    const userArr=useSelector(state=>state?.subdivSelect?.subdivData?.checkedArr)
    const filtervals = useSelector(state => state?.systemConfigData?.filterState)
    // const [trigger, result, lastPromiseInfo] = useLazyGetUsersQuery({refetchOnFocus:false });
    const initialState={
        "start_date":'',
        "end_date":'',
        "organization_id":"",
        'organization_name':'',
        "subdivision_ids":[],
        "status":[]
    }
    const [filterValues,setFilterValues]=useState(initialState)
    const {data,isFetching,isLoading,status}=useGetObserversQuery(searchParams?.toString(),{skip: skip||location.search===''})
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        // Only reset page_number to 1 for search-related changes, not for initialization
        if (key !== 'page_number' && (key === 'search' || key === 'limit')) {
            params.page_number = 1
        }
        // Ensure page_number is a valid number if being set
        if (key === 'page_number' && (isNaN(value) || value < 1)) {
            params[key] = 1
        } else if(key === 'search') {
            params[key] = value; 
        } else {
            params[key] = value
        }
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    

    useEffect(() => {
        if(location.search===''){
            setSkip(true)
        }
        if(location.state!==null&&location.state!==''&& !Array.isArray(location.state)){
            let params={};
            if(location?.state?.search!==''){
                params={
                    'limit':location.state.limit,
                    'page_number':location.state.page_number,
                    'sort':'created_at+desc',
                    'search':decodeURIComponent(location.state.search),
                    'search_mode':location.state.search_mode
                }
            }else{
                params={
                    'limit':location.state.limit,
                    'page_number':location.state.page_number,
                    'sort':'created_at+desc',
                }

            }
            // Set search params directly to preserve pagination state from navigation
            setSearchParams({...params})
            
        }
        else{
            // Only initialize default values if no search params exist
            if(!searchParams.get('limit')){
                handleSearchParams('limit','15')
           
            }
            if(!searchParams.get('page_number')) { 
                handleSearchParams('page_number', '1')
            }
            if(!searchParams.get('sort')) {
                handleSearchParams('sort', `created_at+desc`)
            }
            if(!searchParams.get('filter')) {
                handleSearchParams('filter', `true`)
            }

        }
        
        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')
        
    }, [location]);

    useEffect(()=>{
        if(searchParams.size>=4){
            setSkip(false)
        }
        else{
            setSkip(true)
        }
    },[searchParams])

    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        const start_date=moment(filterValues?.start_date).format('YYYY-MM-DD')
        const end_date=moment(filterValues?.end_date).format('YYYY-MM-DD')
        if (type) {
            // params.filter = "true";
            // Dispatch the filter values to Redux
            dispatch(handleAddFilterValues({
                "start_date":filterValues.start_date,
                "end_date":filterValues.end_date,
                "organization_id":filterValues.organization_id,
                'organization_name':filterValues.organization_name,
                "subdivision_ids":filterValues.subdivision_ids,
                "status":filterValues.status
            }));
            const filteredStatus = filterValues.status && filterValues.status.length > 0
                ? filterValues.status.join(',')
                : null;

            params.page_number=1
            filterValues?.organization_id!==""&&filterValues?.organization_id!==undefined?params["organization_id"]=filterValues.organization_id:''
            filterValues?.subdivision_ids&&filterValues?.subdivision_ids!==undefined&&filterValues?.subdivision_ids?.length>0?params["subdivision_ids"]=filterValues.subdivision_ids?.join(','):''
            filterValues?.start_date!==""&&filterValues?.start_date!==undefined?params["start_date"]=convertDatesToEpochUTC(start_date,Intl.DateTimeFormat().resolvedOptions().timeZone,true):''
            filterValues?.end_date!==""&&filterValues?.end_date!==undefined?params["end_date"]=convertDatesToEpochUTC(end_date,Intl.DateTimeFormat().resolvedOptions().timeZone,false):''
            if (filteredStatus) {
                params['status'] = filteredStatus;
            } else {
                delete params['status'];
            }
            setSearchParams({ ...params });
        } else {
            // Clear filterValues when type is false
            setFilterValues({
                "start_date":'',
                "end_date":'',
                "organization_id":"",
                "subdivision_ids":[],
                "status":""
            });
            dispatch(popFromSubDivArray(['clearall']))
    
            // Remove filter-related keys from searchParams
            
            // delete params['filter'];
            params["organization_id"]&& delete params["organization_id"]
            params["subdivision_ids"]&&delete params["subdivision_ids"]
            params["status"]&&delete params["status"]
            params.start_date&&delete params.start_date
            params.end_date&&delete params.end_date
            setSearchParams({ ...params });
        }
    };
   
    function handleNoOfRowsClick(number) {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
       
    }

    useEffect(() => {
        if(data!==undefined){
            dispatch(limitReducer([data,searchParams.get("limit"),searchParams.get("page_number")]))
        }
    }, [data?.data]);

    const handleChange = (val) => {
        handleSearchParams('search', val)
        
    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setEmptyField(false)
        setTextAreaMsg("")
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        
        if((confirmationState?.rowData!==undefined&&confirmationState?.rowData!==""&&confirmationState?.rowData?.status === 'active' && textAreaMsg.trim()=== '')||(confirmationState?.multirow==="deactive"&&(textAreaMsg.trim()===''))){ 
            setToastErrorMessage('Please fill in the mandatory field')
            
            setEmptyField(true)
            return;
        }
        try {
            let body = { }
            if(confirmationState?.rowData!==undefined&&confirmationState?.rowData!==""){
                {confirmationState?.rowData?.status === 'inactive' ?
                    body={
                        "user_names": [confirmationState?.rowData.user_name],
                        "status":confirmationState?.rowData?.status==="inactive"?"active":"inactive",
                        "note" : ''
                    } : 
                    body={
                        "user_names": [confirmationState?.rowData.user_name],
                        "status":confirmationState?.rowData?.status==="inactive"?"active":"inactive",
                        "note" : textAreaMsg 
                    } 
                }
            }
            else{
                confirmationState?.multirow==="deactive"?
                    body={
                        "user_names": (selectedRows?.filter((user)=>user.status!=='inactive'))?.map((item)=>item.name),
                        "status":confirmationState?.multirow==="deactive"?"inactive":"active",
                        "note" : textAreaMsg 
                    }
                    :
                    body={
                        "user_names": (selectedRows?.filter((user)=>user.status!=='active'))?.map((item)=>item.name),
                        "status":confirmationState?.multirow==="deactive"?"inactive":"active",
                        "note" : ''
                        
                    }
            }
            setLoading(true)
            
            
            const activationRes=await editObserver({body})
            
            setLoading(false)
            
            if(activationRes?.error){
                setToastErrorMessage(activationRes?.error?.data?.message)
            }else{
                if(confirmationState?.multirow!==""&&confirmationState?.multirow!==undefined){
                    setToastmessage(`Observers ${confirmationState?.multirow ==="active"?"activated":"deactivated"} successfully`);
                }
                else{
                    setToastmessage(`Observer ${confirmationState?.rowData?.status==="inactive"?"activated":"deactivated"} successfully`);
                }
                
            }
            setTextAreaMsg('');
            dispatch(resetArrays())
            setConfirmationState({})
           
        } catch (error) {
            setConfirmationState({});
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }  

    // handle multi delete
    const handleMultiRowDelete = async () => {
        setLoading(true);
        setMultiDelete(true);
        const observernames = selectedRows.map(item => item.name);

        let body = {
            users: observernames,
        };
        
        const res = await deleteObserver(body);
        
        if (res?.error?.data?.message) {
            setToastErrorMessage(res?.error?.data?.message);
            setIsChangeStatusOpen(false);
            setIsChangeStatusOpenxl(false)
            setLoading(false);
            setMultiDelete(false);
        } else {
            // Increment the page_number by 1 if the devices were on the last page
            const currentPageNumber = parseInt(searchParams.get('page_number')) || 1;
            const updatedPageNumber = (currentPageNumber > 1) ? currentPageNumber - 1 : 1;
            // Update the page_number in the URLSearchParams
            searchParams.set('page_number', updatedPageNumber);
            setSearchParams(Object.fromEntries(searchParams));
            setToastmessage('Observers deleted successfully');
            setLoading(false);
            setMultiDelete(false);
            setIsChangeStatusOpen(false);
            setIsChangeStatusOpenxl(false)
        }
        dispatch(resetArrays());
        setConfirmationState({});
        setLoading(false);
    };
        
    const handleDeleteModelClose = () => {
        setConfirmationState({});
        setIsChangeStatusOpen(false);
        setIsChangeStatusOpenxl(false)
        setMultiDelete(false);
    }

    useEffect(()=>{
        if(searchParams?.get("organization_id")!==null&&filtervals?.organization_id!==undefined){
            setSelectedOrganizationName([{
                organization_name:filtervals['organization_name'] ,
                organization_id: filtervals['organization_id'],
            }])
            
        }
        if(searchParams?.get("subdivision_ids")!==null && filtervals?.subdivision_ids!==undefined){
            dispatch(pushToSubDivArray(['emptyEdit',filtervals?.subdivision_ids?.map(sub => ({
                id: sub,
                name: '',
                isChecked:true,
                isEdit:true
            }))]));
        }

        
    },[])

    // apply search function
    const handleOnSubmit = (e) => {
        e.preventDefault();
        let searchString = '';
        
        const formatSearchValue = (value) => value.trim() === '-' ? '__NULL__' : value.trim();
    
        const searchFields = [
            ['user_id', 'user_id_inverse'],
            ['first_name', 'first_name_inverse'],
            ['last_name', 'last_name_inverse'],
            ['patient_associated', 'patient_associated_inverse', 'patient_full_name'],
        ];
    
        searchFields.forEach(([key, inverseKey, customKey]) => {
            if (observerSearch?.[key]?.trim()) {
                const prefix = observerSearch?.[inverseKey] ? 'ne:' : '';
                const formattedValue = formatSearchValue(observerSearch[key]);
                searchString += `${customKey || key}=${prefix}${encodeURIComponent(formattedValue)};`;
            }
        });
    
        const emailFields = [
            ['user_name', 'user_name_inverse', 'user_name_domain'],
            ['email_address', 'email_address_inverse', 'email_address_domain']
        ];
        
        emailFields.forEach(([key, inverseKey, domainKey]) => {
            if (observerSearch?.[key] || observerSearch?.[domainKey]) {
                const prefix = observerSearch?.[inverseKey] ? 'ne:' : '';
                const formattedValue = formatSearchValue(observerSearch[key] || '');
                const formattedDomain = formatSearchValue(observerSearch[domainKey] || '');
                searchString += `${key}=${prefix}${encodeURIComponent(formattedValue)}@${encodeURIComponent(formattedDomain)};`;
            }
        });
    
        const numberFields = [
            ['mobile_number_code', 'mobile_number', 'mobile_number_inverse', 'mobile_country_code-mobile_number'],
            ['main_number_code', 'main_number', 'main_number_inverse', 'main_country_code-main_number']
        ];
    
        numberFields.forEach(([codeKey, numberKey, inverseKey, combinedKey]) => {
            if (observerSearch?.[codeKey] || observerSearch?.[numberKey]) {
                const prefix = observerSearch?.[inverseKey] ? 'ne:' : '';
                const formattedCode = formatSearchValue(observerSearch[codeKey] || '');
                const formattedNumber = formatSearchValue(observerSearch[numberKey] || '');
                searchString += `${combinedKey}=${prefix}${formattedCode ? '+' : ''}${encodeURIComponent(formattedCode)}-${encodeURIComponent(formattedNumber)};`;
            }
        });
        
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;
        
        const currentParams = Object.fromEntries(searchParams);
        const newParams = {
            ...currentParams,
            search: searchString || '',
            search_mode: observerSearch.match === false ? 'and' : 'or',
            page_number: 1,
            sort: currentParams.sort || 'created_at+desc',
            limit: currentParams.limit || '15',
        };
        
        if (!newParams.search) delete newParams.search;
        setSearchParams(newParams);
        dispatch(setObsSearchApplied());
    };
    
    

    useEffect(() => {
        // If search was not applied, reset the search fields on page load
        if (!searchApplied) {
            dispatch(resetObserverSearch());
        }
    }, [dispatch, searchApplied]);

    const handleDelete = async (username) => {
        setLoading(true);
        let body = {
            users: [username]
        };
        const res = await deleteObserver(body);
        if (res?.error?.data?.message) {
            setToastErrorMessage(res?.error?.data?.message);
            setLoading(false);
            setEmptyField(false)
            setTextAreaMsg("")
            setConfirmationState({})
        } else {
            setSearchParams(Object.fromEntries(searchParams));
            setToastmessage('Observer deleted successfully');
            setLoading(false);
            handleConformationClick();
        }
    };


    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Observers"}/>
                <div className='bg-white rounded-lg pt-3 h-customh3 relative'>
                    <div className="px-6">
                        <TopBarIndividual 
                            title={'List of Observers'}
                            path={'/manage-observer/add-observer'}
                            AddButton={true}
                            SearchInput={((data?.data?.length===0 &&searchParams.get("search")===null) ||data===undefined) ? false : true}
                            SearchPlaceholder={'Search for ID,Username etc'}
                            buttonName={"Add Observer"}
                            menuBar={(data!==undefined&&data?.data?.length>0&&selectedRows?.length>0) ? true : false}
                            ApplyFilter={true}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            toAddScreen={'/manage-observer/add-observer'}
                            setConfirmationState={setConfirmationState}
                            optimizedFn={optimizedFn}
                            data={data}
                            exportCols={['ID','Username','First Name','Last Name','Status','Patient Associated with','Organization Name','Sub Division Name','Email Address','Mobile Number','Main Number','Created Date']}
                            isColumnSelect={isColumnSelect}
                            setMultiDelete={setMultiDelete}
                            setIsColumnSelect={setIsColumnSelect}
                            exportObservers={exportObservers}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            handleApplyFilter={handleApplyFilter}
                            selectedOrganizationName={selectedOrganizationName}
                            setSelectedOrganizationName={setSelectedOrganizationName}
                            setSubDivisionDataLoading={setSubDivisionDataLoading}
                            userArr={userArr}
                            setTextAreaMsg={setTextAreaMsg}
                            subDivisionDataLoading={subDivisionDataLoading}
                        />
                    </div>
                    {((isFetching&&status!=="fulfilled"&&status!=="rejected"&&!isSortselected)||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Observers list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay':'overlay-list'}`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>
                        <div className="px-6">
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setisSortSelected={setisSortSelected}
                                setConfirmationState={setConfirmationState}
                                setTextAreaMsg={setTextAreaMsg}
                                handleDelete={handleDelete}
                                loading={loading}
                                setLoading={setLoading}
                            />
                        </div>
                        {data?.total_count>=15 &&<div className="w-[100%] px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-[8px]">
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />
                        
                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </>:<>
                        {(data?.total_count === 0 &&suggestions?.trim()!=="") || (data?.success_status === "false") ||(searchParams.get('status')!==null||searchParams.get('organization_id')!==null||searchParams.get('subdivision_ids')!==null||searchParams.get('start_date')!==null||searchParams.get('end_date')!==null||searchParams.get('provider_credential')!==null) ?
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                            :
                            data?.total_count===0&&!searchParams.get("search")?<Emptyscreen
                                title={"Manage Observers"}
                                FirstPTag={"No Observers added yet."}
                                SecondePTag={"Start managing by clicking Add Observer"}
                            />:((status==="rejected"||(data?.total_count!==0&&data?.data?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                        }
                    </>}
                </div>
                {confirmationState.isOpen  && 
                    <AnimatedModel 
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyField}
                                setEmptyField={setEmptyField}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                disabled={loading}
                                handleOnCLickActivate={handleOnCLickActivate}
                                handleClose={handleConformationClick}
                                tittle= {confirmationState?.rowData!==""?confirmationState?.rowData?.status==="inactive"? 'Activate' : 'Deactivate':confirmationState.multirow==="active"?'Activate':'Deactivate'}
                                message = {confirmationState.rowData!==""?`Are you sure you want ${confirmationState?.rowData?.status==="inactive"? 'activate' : 'deactivate'} the observer?`:
                                    `Are you sure you want to ${confirmationState.multirow==='active'?'activate':'deactivate'} the following observers?`}
                                textMessage = {confirmationState.rowData!==""?confirmationState?.rowData?.status === 'inactive' ? true : false:confirmationState.multirow==="active"?true:false}
                                buttonName = {confirmationState.rowData!==""?confirmationState?.rowData?.status==="inactive"? 'Activate' : 'Deactivate':confirmationState.multirow==='active'?'Activate':'Deactivate'}
                                userList={confirmationState?.multirow===''?'':confirmationState?.multirow==="deactive"?(selectedRows?.filter((user)=>user.status!=='inactive'))?.map((item)=>item.name):(selectedRows?.filter((user)=>user.status!=='active'))?.map((item)=>item.name)}
                                loadingActivation={loading}
                            />
                        }
                    /> 
                }
                {/* delete confirmation prompt */}
                {multiDelete &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                handleOnCLickActivate={handleMultiRowDelete}
                                handleClose={handleDeleteModelClose}
                                tittle={'Delete'}
                                message={`Are you sure you want to delete the following observers?`}
                                userList={ selectedRows.map(item => item.name)}
                                buttonName={"Delete"}
                                data_testid="delete-btn"
                                loadingActivation={loading}
                               
                            />
                        }
                    />
                }
                {isAdvancedSearchOpen&&searchParams?.get('limit')&&!searchParams?.get('target_user_name') &&
                    <ObserverAdvancedSearch                    
                        handleOnSubmit={handleOnSubmit}
                        emptyField={emptyField}
                        setEmptyField={setEmptyField}
                    />
                }
            </div>
        </>
   
    )
}